import { Typography } from '@euler/app/components/typography';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { HeaderTitle } from '@react-navigation/elements';
import color from 'color';
import { StyleProp, Text, TextStyle, View } from 'react-native';
import { useTheme } from 'styled-components';

export const NavHeaderTitle = (
  props: Parameters<typeof HeaderTitle>[0] & {
    titleStyle?: StyleProp<TextStyle>;
  },
) => {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  if (typeof props.children !== 'string') {
    return <></>;
  }
  const [title, subtitle] = props.children!.split('\n');
  // $hack(eric): allow use directive/modifier in form of
  // `!color[#aabbcc] text` to set the sub title color.
  const m = subtitle ? /^!color\[(.+?)\]\s(.+?)$/.exec(subtitle) : null;
  const subTitleColor =
    m?.[1] ??
    (props.tintColor
      ? color(props.tintColor).fade(0.6).string()
      : theme.page.header.subTitleColor);
  const subTitle = m?.[2] ?? subtitle;
  return (
    <View
      css={`
        flex: 1;
        align-items: center;
        justify-content: center;
        align-self: center;
      `}
    >
      <Text
        css={`
          font-family: ${FontFamily.NotoSans.Regular};
          font-size: ${rpx(18)}px;
          line-height: ${rpx(20)}px;
          color: #000;
        `}
        style={props.titleStyle}
      >
        {title}
      </Text>
      {subTitle ? (
        <Typography.Label
          thin
          size={rpx(12)}
          lineHeight={rpx(14)}
          color={subTitleColor}
        >
          {subTitle}
        </Typography.Label>
      ) : null}
    </View>
  );
};

export const NavHeaderTitleForIpadLandscape = (
  props: Parameters<typeof HeaderTitle>[0],
) => {
  const { rpx } = useResponsiveContext();
  return (
    <NavHeaderTitle
      {...props}
      titleStyle={{
        fontSize: rpx(24),
        lineHeight: rpx(30),
        fontFamily: FontFamily.NotoSans.Regular,
      }}
    />
  );
};

export const NavHeaderTitleForIpadPortrait = (
  props: Parameters<typeof HeaderTitle>[0],
) => {
  const { rpx } = useResponsiveContext();
  return (
    <NavHeaderTitle
      {...props}
      titleStyle={{
        fontSize: rpx(18),
        lineHeight: rpx(24),
        fontFamily: FontFamily.NotoSans.Regular,
      }}
    />
  );
};
